import Vue from 'vue'
import AscTooltip from '@/components/atoms/AscTooltip'
import AscLabel from '@/components/atoms/AscLabel'
import { daysDifference } from '@/utilities/dates'

export default Vue.extend({
  components: {
    AscTooltip,
    AscLabel,
  },

  data: function () {
    return {}
  },

  computed: {
    getDataValue() {
      const daysDiff = daysDifference(new Date(this.params.value), new Date())
      return `${daysDiff} days ago`
    },
    getTooltip() {
      return `Connectivity Alert: >7 Days since last connection`
    },
  },

  template: `<div style="display: flex;">
      <asc-label style="padding-bottom: 4px;" size="sm" :value="getDataValue"></asc-label>
      <asc-tooltip :tooltip="getTooltip" top :tooltip-length="0">
        <v-icon style="padding-left: 16px;" size="16" color="#FF0000">mdi-wifi-strength-off</v-icon>
      </asc-tooltip>
    </div>`,
})
